import React from "react";

import { color } from "../../tokens";
import { Box } from "../Box/Box";
import { Option, Select } from "../Select/Select";
import { DateRange, Props as DateRangeProps } from "./DateRange";
import { useDateRangeWithReportingYears } from "./useDateRangeWithReportingYears";

interface Props extends DateRangeProps {
  reportingYears: (Option<string> & { startDate: string; endDate: string })[];
  reportingYearsPlaceholder?: string;
}

export const DateRangeWithReportingYears: React.FC<Props> = (props) => {
  const {
    reportingYears,
    reportingYearsPlaceholder,
    onChange,
    translate,
    ...rest
  } = props;

  const { selectedReportingYear, handleSelect, closePopoverEvent } =
    useDateRangeWithReportingYears(props);

  const optionGroup = { options: reportingYears };
  return (
    <DateRange
      header={
        <Box mt={1} mb={1}>
          <Select
            placeholder={
              reportingYearsPlaceholder ||
              (translate("selectReportingPeriod", {
                namespace: "DEFAULT",
              }) as string)
            }
            onChange={(option) => option && handleSelect(option.value)}
            options={[optionGroup]}
            selectProps={{
              sx: { backgroundColor: color.neutral[200] },
              size: "small",
            }}
            selectedOption={selectedReportingYear}
            data-testid="reporting-year-select"
          />
        </Box>
      }
      closePopoverEvent={closePopoverEvent}
      onChange={onChange}
      translate={translate}
      {...rest}
    />
  );
};
